<template>
    <div class="VLabelCombobox">
        <div class="VLabelCombobox-items">
            <div
                class="VLabelCombobox-items__item"
                v-for="(item, itemIndex) in items"
                :key="itemIndex"
            >
                <VLabel
                    :color="'#6089E7'"
                    :action="'remove'"
                    @click="itemRemove(itemIndex)"
                >
                    {{ item }}
                </VLabel>
            
            </div>
        </div>
        <VInput
            class="VLabelCombobox-input"
            v-model="inputValue"
            is-tab-like-enter
            @enter="inputEnter"
            @tab="inputEnter"
        ></VInput>
    </div>
</template>

<script>
    export default {
        name: 'VLabelCombobox',
        props: {
            items: {
                type: Array,
                required: true,
                default: () => ([]),
            },
        },
        data() {
            return {
                inputValue: '',
            };
        },
        methods: {
            inputEnter() {
                if (this.inputValue.length){
                    const newItems = _.cloneDeep(this.items);
                    newItems.push(this.inputValue);
                    this.inputValue = '';
                    this.$emit('update:items', newItems);
                    this.$emit('change');
                }
            },
            itemRemove(index) {
                const newItems = _.cloneDeep(this.items);
                newItems.splice(index, 1);
                this.$emit('update:items', newItems);
                this.$emit('change');
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VLabelCombobox {
        border: 1px solid $primary-color;
        border-radius: 4px;
        
        &.invalid {
            border: none;
        }
        
        display: flex;
        align-items: center;
        width: 273px;
        flex-wrap: wrap;
        
        &-items {
            display: flex;
            flex-wrap: wrap;
            
            &__item {
                margin-left: 10px;
                
                ::v-deep .VLabel {
                    margin: 0 !important;
                }
            }
            
        }
        
        &-input {
            ::v-deep input {
                width: 260px !important;
                border: none;
            }
        }
    }
</style>